// ------------------------------------
// Constants
// ------------------------------------
export const CHARITY_SHOW_WINDOW = 'CHARITY_SHOW_WINDOW';
export const CHARITY_SHOW_INFO_WINDOW = 'CHARITY_SHOW_INFO_WINDOW';
export const ASK_FOR_CHARITY_SHOW_WINDOW = 'ASK_FOR_CHARITY_SHOW_WINDOW';

// ------------------------------------
// Actions
// ------------------------------------
export function charityVisible (show = false) {
  return {
    type    : CHARITY_SHOW_WINDOW,
    payload : show
  }
}

export function charityInfoModalVisible (show = false) {
  return {
    type    : CHARITY_SHOW_INFO_WINDOW,
    payload : show
  }
}

export function askForCharityVisible (show = false) {
  return {
    type    : ASK_FOR_CHARITY_SHOW_WINDOW,
    payload : show
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
export function charityWindowReducer (state = false, action) {
    return action.type === CHARITY_SHOW_WINDOW
        ? action.payload
        : state
}

export function charityInfoWindowReducer (state = false, action) {
  return action.type === CHARITY_SHOW_INFO_WINDOW
      ? action.payload
      : state
}

export function askForCharityWindowReducer (state = false, action) {
  return action.type === ASK_FOR_CHARITY_SHOW_WINDOW
      ? action.payload
      : state
}


// WEBPACK FOOTER //
// ./src/store/charity.js